export const formatDateToBack = (date: Date) => {
  return `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()} ${date.getUTCHours()}:${date.getMinutes()}:${date.getSeconds()}`
}
